import styled from 'styled-components';

export const CreditsContainer = styled.div`
  margin: 75px auto 167px;
  width: min-content;
  display: flex;
  flex-direction: column;
  padding: 0 calc(var(--spacing-m) * 2);
  gap: var(--spacing-xl);
`;

export const ColumnContainer = styled.div`
  display: flex;
  gap: var(--spacing-xl);
`;

export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xl);
  width: 770px;
`;
